import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';

const InsuranceModal = ({ isOpen, onClose }) => {
  const insuranceSections = [
    {
      title: "Insurance Coverage",
      content: "The rates include 3rd party insurance. Third party Insurance, covering third person against property damages and body injuries."
    },
    {
      title: "Car Insurance C.D.W.",
      content: `Car Insurance C.D.W. (Collision Damage Waiver) is optionally available at an extra cost as follows:

For Groups B, Β1 – B3 with deductible (excess) the first 800€ at 10€ daily
Groups C, D with deductible (excess) the first 1.000€ at 15€ daily
Groups D1, E, G, G1, S, S1 – S3 with deductible (excess) the first 1.000€ at 20€ daily
Groups H1, H2, L with deductible (excess) the first 2.000€ at 30€ daily
Groups G2 – G6, L1 – L3, S4 with deductible (excess) the first 2.500€ at 50€ daily
Groups G7, H3 with deductible (excess) the first 5.000€ at 55€ daily`
    },
    {
      title: "Super Collision Damage Waiver (S.C.D.W)",
      content: `Super Collision Damage Waiver (S.C.D.W) insurance is also optionally available, it reduces the above deductible amounts of C.D.W at a premium price and is available as follows:

For Groups B, Β1 – B3 with deductible (excess) the first 600€ at 15€ daily
Groups C, D with deductible (excess) the first 800€ at 20€ daily
Groups D1, E, G, G1, S, S1 – S3 with deductible (excess) the first 800€ at 30€ daily
Groups H1, H2, L with deductible (excess) the first 1.800€ at 45€ daily
Groups G2 – G6, L1 – L3, S4 with deductible (excess) the first 2.000€ at 65€ daily
Groups G7, H3 with deductible (excess) the first 4.600€ at 70€ daily

C.D.W Collision damage waiver Insurance or S.C.D.W means that LUXURY CAR MYKONOS rented vehicle is insured towards collision damages (material damages) also caused by the renter, but with an excess amount to pay as described in the respective tables above.

Mechanical damages are not covered by the C.D.W Collision damage waiver Insurance or S.C.D.W Super Collision Damage Waiver.`
    },
    {
      title: "No Insurance Coverage",
      content: `No insurance coverage shall apply to:
• Damages, loss or theft of personal belongings kept in the car.
• Loss of vehicle keys
• Any incident inside the car during transport by ship or any other means.
• Any incident occurred while the driver was under the influence of alcohol or drugs.
• Accidents caused when the driver has not been declared in the rental contract.
• Damages of the inside of the vehicle.`
    },
    {
      title: "Exceptions to C.D.W and S.C.D.W Insurance",
      content: `Neither S.C.D.W nor C.D.W insurance covers for the following damages:
• antennas, mirrors, lights, windows, windshield wipers, loss of registration plates.
• trays, hubcap, gas cap, wheels, tire punctures, burst tires, fuel errors, lack of electricity because of forgotten turn on electrical devices.
• car jacks, damage to the car locks, loss or damage of keys or spare key, warning triangles.
• damage or extreme dirtiness to the exterior or the interior of the vehicle, underside damage, damage to the seats or child/baby seats, theft of vehicle accessories or personal belongings that were in the rented vehicle.
• Theft or loss of the vehicle.

All rental vehicle are insured for a maximum number of passengers. For your safety, this number should not be exceeded and in case this number is exceeded the insurance will be invalidated and a fine will be charged. Please make sure the vehicle you book is big enough for your needs.

Moreover, LUXURY CAR MYKONOS shall not compensate the client for any damage caused by negligence. We may consider as negligence any damage unnoticed by the driver. Such damages also have to be paid by the client himself. Additionally, in any circumstances, Insurance does not cover damages from bad weather conditions such as storms, floods, tornadoes, fallow trees, etc. LUXURY CAR MYKONOS shall not pay for any telephones, hotels or taxis used after an accident.`
    },
    {
      title: "Parking fines/ traffic tickets",
      content: "The renter of the vehicle is solely responsible for any traffic offence fines and related administration fees incurred during their rental period. All traffic tickets and other consequences are charged to the renter no matter the date that LUXURY CAR MYKONOS informed about that."
    },
    {
      title: "Lost or damage of key",
      content: `In case of loss or damage of vehicle key during the rental, the renter is liable for following charges:

For Groups B, Β1, Β2, B3 total cost 80,00€
Groups C, D total cost 150,00€
Groups D1, E, G, G1, S, S1, S2, S3 total cost 300,00€
Groups H1, H2, L, L1 total cost 300,00€
Groups G2, G3, G4, G5, G6, L2, L3, S4 total cost 300,00€
For Groups G7, H3 total cost 300,00€`
    },
    {
      title: "Accident/ Breakdown/ Theft Assistance",
      content: `In case of an accident / theft involving your rental car you should immediately contact LUXURY CAR MYKONOS company. The vehicle should not be removed from the place of the accident!

If you do not report the accident to the company or the police in compliance to the Greek law, the insurance may become invalid. The report should state if there was any influence of alcohol or drugs. You should also report any accident or damage to our car rental company.

The above procedure should also be followed in case of other damages to the rental vehicle.

In case the rental vehicle is damaged while parked you have to report the damage to the car rental company before you move the vehicle.
In case of theft, the client is obliged to file a police report and to hand this document over to the car rental company. You should also inform our car rental company immediately about any theft. The documentation and keys of the vehicle should be returned to our car rental company.
The client should report all damages IMMEDIATELY to our car rental company.
Any accident or damage to the vehicle that has not been reported may be interpreted as negligence, which may result in charging the client.`
    },
    {
      title: "Taxes",
      content: "All prices and charges listed on the reservation form include VAT and all City and State taxes."
    }
  ];

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4 Aleo"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-hidden relative"
        >
          {/* Header */}
          <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">Mykonos Car Rentals Insurance</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <IoClose size={24} />
            </button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-80px)] p-6">
            <div className="space-y-8">
              {insuranceSections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className={`flex flex-col md:flex-row gap-6 ${
                    index !== insuranceSections.length - 1 ? 'pb-8 border-b border-gray-200' : ''
                  }`}
                >
                  <div className="md:w-1/3">
                    <h3 className="text-lg font-semibold text-blue-900">{section.title}</h3>
                  </div>
                  <div className="md:w-2/3">
                    <div className="text-gray-600 whitespace-pre-line">{section.content}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InsuranceModal;